import React, { useEffect } from 'react';
import { DatabaseIcon } from 'lucide-react';
import { StepProps } from '../../types/onboarding';
const PROFILES = ['Assistant Profile', 'JR System Administrator', 'Junior Processor', 'Loan Officer Profile', 'Loan Officer Profile II', 'Processing Manager', 'Processor', 'Processor Restricted', 'Sales Manager', 'Sales Manager - Platform', 'Sales Manager Chris', 'Solution Desk', 'Upsell', 'System Administrator', 'Read Only', 'Read Only1', 'Standard Platform User'];
const ROLES = ['Jr. Loan Officer', 'Jr Processor', 'Ladera Ranch CA Branch', 'Ladera Ranch CA Loan Officers', 'Processor', 'Processor Manager', 'Retail', 'Solution Desk', 'Upsell'];
export function UserDetails({
  data,
  updateData,
  setCanAdvance
}: StepProps) {
  useEffect(() => {
    const isFormValid = !!(data.firstName.trim() && data.lastName.trim() && data.alias.trim() && data.username.trim() && data.email.trim() && data.profile && data.role);
    setCanAdvance(isFormValid);
  }, [data, setCanAdvance]);
  const handleNameChange = (field: 'firstName' | 'lastName', value: string) => {
    const updates: any = {
      [field]: value
    };
    const first = field === 'firstName' ? value : data.firstName;
    const last = field === 'lastName' ? value : data.lastName;
    if (first && last && !data.alias) {
      updates.alias = `${first.charAt(0).toLowerCase()}${last.substring(0, 4).toLowerCase()}`;
    }
    updateData(updates);
  };
  const accountName = data.firstName && data.lastName ? `${data.firstName} ${data.lastName} Database` : 'New User Database';
  const inputClass = 'w-full border-0 border-b border-gray-300 rounded-none px-0 py-2 text-sm focus:outline-none focus:border-[#2563EB] focus:ring-0 bg-transparent transition-colors';
  const selectClass = `${inputClass} appearance-none cursor-pointer`;
  const labelClass = 'block text-xs font-medium text-gray-500 uppercase tracking-wide mb-1';
  return <div className="space-y-8" data-id="element-276">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6" data-id="element-277">
        <div data-id="element-278">
          <label className={labelClass} data-id="element-279">
            First Name <span className="text-red-500" data-id="element-280">*</span>
          </label>
          <input type="text" value={data.firstName} onChange={e => handleNameChange('firstName', e.target.value)} className={inputClass} placeholder="Jane" data-id="element-281" />
        </div>
        <div data-id="element-282">
          <label className={labelClass} data-id="element-283">
            Last Name <span className="text-red-500" data-id="element-284">*</span>
          </label>
          <input type="text" value={data.lastName} onChange={e => handleNameChange('lastName', e.target.value)} className={inputClass} placeholder="Doe" data-id="element-285" />
        </div>
        <div data-id="element-286">
          <label className={labelClass} data-id="element-287">
            Alias <span className="text-red-500" data-id="element-288">*</span>
          </label>
          <input type="text" value={data.alias} onChange={e => updateData({
          alias: e.target.value
        })} maxLength={8} className={inputClass} placeholder="jdoe" data-id="element-289" />
        </div>
        <div data-id="element-290">
          <label className={labelClass} data-id="element-291">
            Email <span className="text-red-500" data-id="element-292">*</span>
          </label>
          <input type="email" value={data.email} onChange={e => updateData({
          email: e.target.value
        })} className={inputClass} placeholder="jane.doe@company.com" data-id="element-293" />
        </div>
        <div className="md:col-span-2" data-id="element-294">
          <label className={labelClass} data-id="element-295">
            Username <span className="text-red-500" data-id="element-296">*</span>
          </label>
          <input type="email" value={data.username} onChange={e => updateData({
          username: e.target.value
        })} className={inputClass} placeholder="jane.doe@company.com.prod" data-id="element-297" />
        </div>
        <div className="relative" data-id="element-298">
          <label className={labelClass} data-id="element-299">
            Profile <span className="text-red-500" data-id="element-300">*</span>
          </label>
          <select value={data.profile} onChange={e => updateData({
          profile: e.target.value
        })} className={selectClass} data-id="element-301">
            <option value="" disabled data-id="element-302">
              Select Profile
            </option>
            {PROFILES.map(p => <option key={p} value={p} data-id="element-303">
                {p}
              </option>)}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 top-5 flex items-center px-2 text-gray-400" data-id="element-304">
            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-305">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-306"></path>
            </svg>
          </div>
        </div>
        <div className="relative" data-id="element-307">
          <label className={labelClass} data-id="element-308">
            Role <span className="text-red-500" data-id="element-309">*</span>
          </label>
          <select value={data.role} onChange={e => updateData({
          role: e.target.value
        })} className={selectClass} data-id="element-310">
            <option value="" disabled data-id="element-311">
              Select Role
            </option>
            {ROLES.map(r => <option key={r} value={r} data-id="element-312">
                {r}
              </option>)}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 top-5 flex items-center px-2 text-gray-400" data-id="element-313">
            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-314">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-315"></path>
            </svg>
          </div>
        </div>
      </div>

      {/* Account Preview */}
      <div className="bg-gray-50 rounded-lg p-4 flex items-center space-x-4 border border-gray-100" data-id="element-316">
        <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0 shadow-sm border border-gray-100" data-id="element-317">
          <DatabaseIcon className="w-5 h-5 text-[#2563EB]" data-id="element-318" />
        </div>
        <div data-id="element-319">
          <p className="text-xs text-gray-500 uppercase tracking-wide font-medium mb-0.5" data-id="element-320">
            Account Record to be created
          </p>
          <p className="text-sm font-semibold text-gray-900" data-id="element-321">{accountName}</p>
        </div>
      </div>
    </div>;
}